import { SettingConst } from '@faire/web-api--source/types';

/**
 * Staging-only, date time value to allow us to switch the current day.
 *  Allows for testing of time dependent content like tips or urgency on enrolment
 */
export const HOLIDAY_SPEND_CHALLENGE_CURRENT_DATE_OVERRIDE =
  'HOLIDAY_SPEND_CHALLENGE_CURRENT_DATE_OVERRIDE' as SettingConst<
    'HOLIDAY_SPEND_CHALLENGE_CURRENT_DATE_OVERRIDE',
    string,
    'RETAILER'
  >;
